export const colors = {
  grey: {
    100: '#00070F',
    90: '#020F20',
    80: '#152232',
    70: '#2D3949',
    60: '#5F6978',
    50: '#7E8796',
    40: '#AFB6C4',
    30: '#D6DBE7',
    20: '#E8EBF2',
    10: '#F5F6FA',
  },
  blue: {
    100: '#0D0D48',
    90: '#032497',
    80: '#032DC4',
    70: '#0535E4',
    60: '#023AFF',
    50: '#1A4CFF',
    40: '#305DFF',
    30: '#4970FF',
    20: '#6282FF',
    10: '#829EFF',
  },
  green: {
    100: '#075819',
    90: '#117827',
    80: '#1A9535',
    70: '#21AF40',
    60: '#25C549',
    50: '#29DA52',
    40: '#45EC6C',
    30: '#77FD96',
    20: '#B2FFC4',
    10: '#CDFFD9',
  },
  yellow: {
    100: '#C49A23',
    90: '#DBB031',
    80: '#E8B71A',
    70: '#F8C304',
    60: '#FFD125',
    50: '#FFD836',
    40: '#FDE568',
    30: '#FAE496',
    20: '#FFDFC4',
    10: '#FFF8E4',
  },
  orange: {
    100: '#D46442',
    90: '#E16340',
    80: '#FF6335',
    70: '#FF764D',
    60: '#FF86D6',
    50: '#FFA286',
    40: '#FFB39C',
    30: '#FFC6B4',
    20: '#FFD5C9',
    10: '#FFE5DD',
  },
  red: {
    100: '#DD0038',
    90: '#EC0B44',
    80: '#FF0F4C',
    70: '#FF2D61',
    60: '#FF507C',
    50: '#FF7195',
    40: '#FF99B2',
    30: '#F9B3C3',
    20: '#FFCBD8',
    10: '#FDE6EB',
  },
  purple: {
    100: '#7918A0',
    90: '#850EB7',
    80: '#9811D1',
    70: '#B145E9',
    60: '#C976FC',
    50: '#DFAAFF',
    40: '#E4C0F8',
    30: '#F2D5FF',
    20: '#F6E2FF',
    10: '#FBF1FF',
  },
  pink: {
    100: '#BE0163',
    90: '#DB0178',
    80: '#FA0281',
    70: '#FF0095',
    60: '#FF41A2',
    50: '#FF73C4',
    40: '#FF7ADA',
    30: '#FFC4E2',
    20: '#FFDEF0',
    10: '#FFF2F9',
  },
  softPurple: {
    100: '#4A2190',
    90: '#6E3DC1',
    80: '#8735DF',
    70: '#864FE2',
    60: '#8E68ED',
    50: '#9C8AFF',
    40: '#B2A4FF',
    30: '#C8BFFF',
    20: '#D0D8FF',
    10: '#ECE9FB',
  },
};
